// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-heatmap-title {
  background-color: #F7FAFC;
  font-size: 14px;
  font-weight: bold;
  color: #142B31;
  display: flex;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #D3E1ED;
}
.view-heatmap-title .heatmap-header-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Heatmaps/ViewHeatmap/ViewHeatmap.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AACD;AACC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AACF","sourcesContent":[".view-heatmap-title {\n\tbackground-color: #F7FAFC;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: #142B31;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 20px 30px;\n\tborder-bottom: 1px solid #D3E1ED;\n\n\t.heatmap-header-buttons {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tmargin-right: 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
